<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 16 16"
  >
    <g fill="none" fill-rule="evenodd">
      <g :fill="color">
        <g>
          <g>
            <path
              d="M10.492 13.542c.253.11.369.405.258.658C10.276 15.284 9.204 16 8 16c-1.203 0-2.275-.715-2.75-1.798-.11-.253.004-.548.257-.659.253-.11.548.004.659.257C6.483 14.523 7.198 15 8 15c.803 0 1.518-.477 1.834-1.2.11-.253.405-.369.658-.258zM8 0l.235.005C10.896.13 13 2.326 13 5v.296c0 1.248.665 2.404 1.74 3.02C15.538 8.774 16 9.337 16 10c0 1.354-2.015 2.365-4.886 2.785l-.532.07C9.772 12.95 8.904 13 8 13c-.904 0-1.772-.05-2.582-.145l-.532-.07C2.016 12.365 0 11.355 0 10c0-.663.463-1.226 1.26-1.684C2.334 7.7 3 6.544 3 5.296V5c0-2.761 2.239-5 5-5zm0 1C5.791 1 4 2.791 4 5v.296c0 1.605-.856 3.092-2.243 3.888l-.147.089C1.193 9.539 1 9.795 1 10c0 .54.997 1.107 2.56 1.499L4 11.6c.454.098.946.181 1.47.246l.532.059C6.635 11.966 7.306 12 8 12s1.365-.034 1.998-.094l.533-.059c.523-.065 1.015-.148 1.469-.246l.44-.102C14.003 11.107 15 10.539 15 10c0-.228-.238-.519-.756-.816l-.195-.118C12.776 8.248 12 6.826 12 5.296V5c0-2.139-1.683-3.897-3.8-3.995z"
              transform="translate(-24 -264) translate(0 248) translate(24 16)"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
import VueTypes from 'vue-types';
export default {
  name: 'BellIcon',
  props: {
    height: VueTypes.string.def('16'),
    width: VueTypes.string.def('16'),
    color: VueTypes.string.def('#6783B2'),
  },
};
</script>

<style lang="scss"></style>
